import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider";
import ActionButton from "../account/ActionButton";
function GeneralError({ error }) {

  const errorMessage = error.statusText || error.message;
  console.log("General error: ", errorMessage);

  const navigate = useNavigate();

  const { endSession } = useAuth();

  const handleClick = () => {
    endSession();
    navigate("/");
  };

  const errorHeadline = `Oops something went wrong...`;
  const errorSubMessage1 = `We’re sorry, but it looks like something went wrong on our end. To get back up & running, please click the button below to log in again.`;
  const errorSubMessage2 = `This should quickly resolve the issue & restore your access. If the problem persists, please contact us so we can help you directly.`;

  return (
    <Box>
      <Box sx={{ mx: { xs: 1, sm: 2, md: 3, lg: 4, xl: 10 } }}>
        <Typography
          color="primary.dark"
          variant="h1"
          sx={{ fontWeight: "bold", fontSize: { xs: 24, sm: 26, md: 28, lg: 30, xl: 32 } }}
        >
          {errorHeadline}
        </Typography>
        <Box sx={{ mt: 3 }}>
          <Typography
            variant="h2"
            sx={{ fontSize: { xs: 18, sm: 20, md: 22, lg: 24, xl: 26 } }}
          >
            {errorSubMessage1}
          </Typography>
        </Box>
        <Box sx={{ mt: 3 }}>
          <Typography
            variant="h2"
            sx={{ fontSize: { xs: 18, sm: 20, md: 22, lg: 24, xl: 26 } }}
          >
            {errorSubMessage2}
          </Typography>
        </Box>
        <Box sx={{ mt: 4 }}>
          <ActionButton
            id="error-reset-button"
            variant='contained'
            buttonColor='secondary.main'
            buttonTextColor='primary.contrastText'
            borderColor='transparent'
            hoverColor='primary.contrastText'
            hoverBorderColor='secondary.main'
            hoverTextColor='secondary.main'
            buttonTitle='Click here'
            onClick={handleClick}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default GeneralError;